import React from "react";
import CancelBtn from "../../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../../components/Buttons/SaveBtn";
import { Dialog, MenuItem, Select, TextField } from "@mui/material";
import closeIcon from "../../../../../../assets/images/close-icon.svg";
import styles from "./EditPopup.module.css";
import { useAuthUser } from "react-auth-kit";
import { useDispatch } from "react-redux";
import { updateBatchPayment } from "../../service/Batchslice";

function AddPriceDiscount(props: any) {
  const { isOpen, onClose, batchData, loader, paymentType, selectedCurrency } =
    props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();

  const paymentData = batchData?.paymentDetails?.paymentData;
  const [price, setPrice] = React.useState<string>("");
  const [discountMetric, setDiscountMetric] = React.useState<string>("");
  const [discount, setDiscount] = React.useState<string>("");
  const [discountError, setDiscountError] = React.useState<boolean>(false);

  const handleDiscountMetric = (value: string) => {
    setDiscountMetric(value);
    setDiscount("");
    setPrice(batchData?.paymentDetails?.paymentData?.totalAmount);
  };

  const handleDiscount = (value: string) => {
    const totalAmount = batchData?.paymentDetails?.paymentData?.totalAmount;
    if (value !== "") {
      if (discountMetric === "AMOUNT") {
        if (parseFloat(value) > totalAmount) {
          setPrice("0");
          setDiscount(totalAmount);
        } else {
          setPrice((totalAmount - parseFloat(value)).toString());
          setDiscount(value);
        }
      } else if (discountMetric === "PERCENTAGE") {
        if (parseFloat(value) > 100) {
          setPrice((totalAmount * (1 - 100 / 100)).toString());
          setDiscount("100");
        } else {
          setPrice((totalAmount * (1 - parseFloat(value) / 100)).toString());
          setDiscount(value);
        }
      }
    } else {
      setPrice(totalAmount);
      setDiscount("");
    }

    if (value !== "") {
      setDiscountError(false);
    } else {
      setDiscountError(true);
    }
  };

  const cancelButtonClick = () => {
    setPrice(batchData?.paymentDetails?.paymentData?.totalAmount);
    setDiscount("");
    setDiscountMetric("");
    setDiscountError(false);
    onClose();
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    try {
      let setup = batchData?.paymentDetails?.paymentData?.setupInstallment;
      const body = {
        batchId: batchData?.id,
        paymentType: paymentType,
        totalAmount: batchData?.paymentDetails?.paymentData?.totalAmount,
        discountMetric:
          discountMetric !== "" && parseFloat(discount) > 0
            ? discountMetric
            : "",
        discount:
          discountMetric !== "" && parseFloat(discount) > 0
            ? parseFloat(discount)
            : 0,
        finalAmount: parseFloat(price),
        discountAdded: true,
        enableInstallment:
          batchData?.paymentDetails?.paymentData?.enableInstallment,
        scheduleInstallment:
          batchData?.paymentDetails?.paymentData?.setupInstallment,
        numberOfInstallment: setup
          ? batchData?.paymentDetails?.paymentData?.numberOfInstallment
          : 0,
        mode: setup ? batchData?.paymentDetails?.paymentData?.mode : "",
        startDate: setup
          ? batchData?.paymentDetails?.paymentData?.startDate
          : 0,
        paymentStructure: setup
          ? batchData?.paymentDetails?.paymentData?.paymentStructure
          : [],
        updatedById: authUser?.institute[0]?.id,
        updatedByName: authUser?.firstName + " " + authUser?.lastName,
      };

      const sessionBody = {
        batchId: batchData?.id,
        paymentType: paymentType,
        totalAmount: batchData?.paymentDetails?.paymentData?.totalAmount,
        discountMetric:
          discountMetric !== "" && parseFloat(discount) > 0
            ? discountMetric
            : "",
        discount:
          discountMetric !== "" && parseFloat(discount) > 0
            ? parseFloat(discount)
            : 0,
        finalAmount: parseFloat(price),
        discountAdded: true,
        updatedById: authUser?.institute[0]?.id,
        updatedByName: authUser?.firstName + " " + authUser?.lastName,
      };

      if (!discountError) {
        dispatch<any>(
          updateBatchPayment(paymentType === "SESSION" ? sessionBody : body)
        );
      }
    } catch (error) {}
  };

  React.useEffect(() => {
    if (batchData) {
      setPrice(batchData?.paymentDetails?.paymentData?.totalAmount);
    }
  }, [batchData, isOpen]);

  return (
    <>
      <Dialog
        open={isOpen}
        sx={{
          zIndex: "99999",
          minWidth: "408px",
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "408px",
            maxHeight: "400px",
            minHeight: "200px",
            padding: "16px",
            borderRadius: "8px",
            boxShadow:
              "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
            left: "10%",
            background: "#FFFFFF",
            overflow: "hidden",
          },
        }}
      >
        <div>
          <div
            className={styles.popupHead}
            style={{ padding: "0px", marginBottom: "14PX" }}
          >
            <div className={styles.popupHeadTitle}>Add Discount</div>
            <button
              className={styles.popupHeadClsBtn}
              onClick={cancelButtonClick}
            >
              <img src={closeIcon} alt="closeIcon" />
            </button>
          </div>
          <div className={styles.membershipEditBody}>
            <div className={styles.membershipEditBodyTop}>
              <div className={styles.membershipEditTypeLabel}>Final Price</div>
              <div
                className={styles.membershipTypeFinalPrice}
                style={{ fontFamily: "Roboto" }}
              >
                {price !== "" && selectedCurrency + " " + parseFloat(price)}
              </div>
            </div>
            <div
              className={styles.membershipEditBodyBottom}
              style={{ maxHeight: "185PX", overflowY: "auto" }}
            >
              <div>
                <div className={styles.membershipEditTypeFieldLabel}>
                  Discount Type
                </div>
                <div>
                  <Select
                    id="emi-mode-select"
                    fullWidth
                    MenuProps={{
                      style: {
                        zIndex: 999999,
                        fontSize: "14px",
                      },
                      PaperProps: {
                        style: {
                          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.05)",
                        },
                      },
                    }}
                    sx={{
                      maxHeight: "39PX",
                      textTransform: "capitalize",
                      "& .MuiSelect-outlined": {
                        fontSize: "14px",
                        color: "#142C44",
                      },
                    }}
                    value={discountMetric}
                    onChange={(event) =>
                      handleDiscountMetric(event.target.value as string)
                    }
                  >
                    {[
                      { discountType: "AMOUNT" },
                      { discountType: "PERCENTAGE" },
                    ]?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item.discountType}
                        sx={{
                          fontSize: "12PX",
                          color: "#667085",
                          textTransform: "capitalize",
                          fontWeight: "400",
                        }}
                      >
                        {item?.discountType?.toLowerCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
              <div>
                <div className={styles.membershipEditTypeFieldLabel}>
                  Discount
                </div>
                <div>
                  <TextField
                    id="discountAmount"
                    variant="outlined"
                    type="number"
                    inputProps={{
                      sx: {
                        width: "240px",
                        "&::placeholder": {
                          fontWeight: "400",
                          fontSize: "14px",
                        },

                        "&.MuiOutlinedInput-input": {
                          padding: "8px",
                        },
                      },
                    }}
                    value={discount}
                    onChange={(event) => handleDiscount(event.target.value)}
                    error={discountError}
                    helperText={discountError ? "Please fill valid amount" : ""}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.popupBtnSplit}>
            <CancelBtn onClick={() => cancelButtonClick()} />
            <SaveBtn
              onClick={handleSubmit}
              disabled={
                discountMetric === "" ||
                parseFloat(discount) <= 0 ||
                discount === "" ||
                loader
              }
              loader={loader}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default AddPriceDiscount;
